import { Crisp } from 'crisp-sdk-web';

document.addEventListener('DOMContentLoaded', () => {
  const metaEl = document.querySelector('meta[name="crisp-id"]');

  if (metaEl) {
    const crispId = metaEl.getAttribute('content');

    Crisp.configure(crispId, {
      autoload: false,
    });
  }
});
